import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  
  const DeletePopup = ({ open, onClose, onSubmit }) => {
    const handleSubmit = () => {
      onSubmit();
      onClose();
    };
  
    return (
      <Dialog
        open={open}
        onClose={onClose}
        sx={{
          "& .MuiDialog-paper": { width: "90%", maxWidth: "none" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DialogTitle color="error" align="center">
          Delete calendar
        </DialogTitle>
        <DialogContent>Are you sure you want to delete this calendar?</DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Close
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  export default DeletePopup;
  